export enum InvoiceStatusType {
  Draft = 1,
  Issued,
  Overdue,
  PartiallyPaid,
  Paid,
  Void,
  Refunded,
}
